(() => {
  const hideSenseWaFloat = () => {
    document.querySelectorAll('body > div').forEach((el) => {
      if (el.getAttribute('data-sense-wa-hidden') === 'true') return;
      const style = el.getAttribute('style') || '';
      if (!style.includes('position:fixed') && !style.includes('position: fixed')) return;
      if (!style.includes('9999999')) return;
      if (!el.querySelector('svg')) return;
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('data-sense-wa-hidden', 'true');
    });
  };

  const syncWhatsAppSize = (pill) => {
    const accessibly = pill.querySelector('#accessiblyAppWidgetButton, .accessibly-app-widget-button-container');
    const btn =
      (accessibly && accessibly.querySelector('#accessiblyAppDialogButton, .accessibly-app-widget-button')) ||
      accessibly;
    if (!btn) return;

    const size = Math.round(btn.getBoundingClientRect().width);
    if (!size || size < 24) return;

    pill.style.setProperty('--floating-wa-size', `${size}px`);
    pill.style.setProperty('--floating-wa-icon', `${Math.round(size * 0.62)}px`);
  };

  const parkAccessibly = (pill) => {
    const slot = pill.querySelector('[data-a11y-slot]');
    const accessibly = document.getElementById('accessiblyAppWidgetButton');
    if (!slot || !accessibly) return false;
    if (!slot.contains(accessibly)) slot.appendChild(accessibly);
    syncWhatsAppSize(pill);
    return true;
  };

  const MOBILE_MQ = '(max-width: 1099px)';
  const isMobile = () => window.matchMedia(MOBILE_MQ).matches;

  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));
  const smoothstep = (t) => t * t * (3 - 2 * t);

  const getDefaultBottom = () => {
    if (isMobile() && document.body.classList.contains('template-product')) {
      const peekVar = getComputedStyle(document.documentElement)
        .getPropertyValue('--product-peek-h')
        .trim();
      const peekH = peekVar.endsWith('px') ? parseFloat(peekVar) : 176;
      return peekH + 16;
    }
    return 19.2;
  };

  const rememberPillHome = (pill) => {
    if (pill._dockHome) return;
    pill._dockHome = { parent: pill.parentNode, next: pill.nextSibling };
  };

  const clearPillLift = (pill) => {
    pill.classList.remove('is-at-footer', 'is-docking');
    pill.style.removeProperty('--floating-footer-lift');
  };

  const mountPillInFooter = (pill, dock) => {
    const slot = dock.querySelector('[data-footer-pill-slot]');
    if (!slot) return false;

    rememberPillHome(pill);
    if (!slot.contains(pill)) slot.appendChild(pill);

    pill.classList.add('is-footer-mounted');
    clearPillLift(pill);
    return true;
  };

  const unmountPillFromFooter = (pill) => {
    if (!pill.classList.contains('is-footer-mounted')) return;

    const home = pill._dockHome;
    if (home?.parent) {
      if (home.next && home.next.parentNode === home.parent) {
        home.parent.insertBefore(pill, home.next);
      } else {
        home.parent.appendChild(pill);
      }
    } else {
      document.body.appendChild(pill);
    }

    pill.classList.remove('is-footer-mounted');
    clearPillLift(pill);
  };

  const syncMobileFooterMount = (pill, dock) => {
    if (!dock) {
      unmountPillFromFooter(pill);
      return;
    }

    const dockRect = dock.getBoundingClientRect();
    const viewportH = window.innerHeight;
    const isMounted = pill.classList.contains('is-footer-mounted');
    const shouldMount = isMounted
      ? dockRect.bottom > 0 && dockRect.top < viewportH
      : dockRect.top < viewportH - 48 && dockRect.bottom > 32;

    if (shouldMount) {
      mountPillInFooter(pill, dock);
      return;
    }

    unmountPillFromFooter(pill);
  };

  const getDockTarget = (footer, logo, dock, pill) => {
    const viewportH = window.innerHeight;
    const defaultBottom = getDefaultBottom();
    const gap = 12;

    const spacer = footer.closest('.shopify-section')?.querySelector('.footer-reveal-spacer');
    if (!spacer) return defaultBottom;

    const spacerTop = spacer.getBoundingClientRect().top;
    const rangeStart = viewportH;
    const rangeEnd = viewportH * 0.55;
    const raw = (rangeStart - spacerTop) / (rangeStart - rangeEnd);
    const progress = smoothstep(clamp(raw, 0, 1));

    if (progress <= 0) return defaultBottom;

    const logoRect = logo.getBoundingClientRect();
    const dockBottom = Math.max(defaultBottom, viewportH - logoRect.top + gap);
    return defaultBottom + (dockBottom - defaultBottom) * progress;
  };

  const applyPillBottom = (pill, bottom) => {
    const defaultBottom = getDefaultBottom();
    const wasDocked = pill.classList.contains('is-at-footer');
    const liftOn = bottom > defaultBottom + (wasDocked ? 2 : 6);

    if (liftOn) {
      pill.style.setProperty('--floating-footer-lift', `${Math.round(bottom)}px`);
      pill.classList.add('is-at-footer', 'is-docking');
    } else {
      clearPillLift(pill);
    }
  };

  const initDockMotion = (pill) => {
    let rafId = null;

    const tick = () => {
      rafId = null;
      const footer = document.querySelector('[data-reveal-footer]');
      const logo = document.querySelector('.footer-reveal__logo');
      const dock = document.querySelector('[data-footer-dock]');

      if (!footer || !logo) {
        unmountPillFromFooter(pill);
        applyPillBottom(pill, getDefaultBottom());
        return;
      }

      if (isMobile()) {
        syncMobileFooterMount(pill, dock);
        return;
      }

      unmountPillFromFooter(pill);
      const target = getDockTarget(footer, logo, dock, pill);
      applyPillBottom(pill, target);
    };

    const schedule = () => {
      if (rafId != null) return;
      rafId = requestAnimationFrame(tick);
    };

    return schedule;
  };

  const init = () => {
    const pill = document.querySelector('[data-floating-actions]');
    if (!pill) return;

    hideSenseWaFloat();
    parkAccessibly(pill);
    pill.hidden = false;

    const scheduleDock = initDockMotion(pill);
    scheduleDock();

    const observer = new MutationObserver(() => {
      hideSenseWaFloat();
      parkAccessibly(pill);
      pill.hidden = false;
      scheduleDock();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('scroll', scheduleDock, { passive: true });
    window.addEventListener('resize', () => {
      syncWhatsAppSize(pill);
      scheduleDock();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', () => {
    hideSenseWaFloat();
    const pill = document.querySelector('[data-floating-actions]');
    if (!pill) return;
    parkAccessibly(pill);
    pill.hidden = false;
    window.setTimeout(() => {
      syncWhatsAppSize(pill);
      initDockMotion(pill)();
    }, 400);
    window.setTimeout(() => {
      syncWhatsAppSize(pill);
      initDockMotion(pill)();
    }, 1200);
  });
})();
